import CreateEvaluacionAnualAdapter from './adapters/CreateEvaluacionAnualAdapter'

class CreateEvaluacionAnual {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute({ idPersonalEvaluado, idPersonalEvaluador, estatus, fecha, tipoEvaluacion, reactivos }) {
    const payload = CreateEvaluacionAnualAdapter.toDto({
      idPersonalEvaluador,
      estatus,
      fecha,
      reactivos,
      tipoEvaluacion,
    })

    await this.#repository.create(idPersonalEvaluado, payload)
  }
}

export default CreateEvaluacionAnual
